import React from 'react';
import { motion } from 'framer-motion';
import { FaCode, FaPaintBrush, FaRocket, FaServer } from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <section id="about" className="section about">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="section-title text-gradient">The Architect</h2>
          <div className="title-underline"></div>
        </motion.div>

        <div className="about-bento-grid">
          <motion.div className="bento-card glass-panel col-span-2 hover-target" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <h3 className="bento-title">Engineering Philosophy</h3>
            <p className="bento-text">
              I am a dedicated Software Engineer obsessed with the fine details of system architecture and premium user experiences. By combining robust backend engineering with pixel-perfect frontend design, I build digital products that don't just work flawlessly—they feel magical.
            </p>
          </motion.div>

          <motion.div className="bento-card glass-panel hover-target bento-center" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}>
            <FaCode className="bento-icon text-accent-1" />
            <h4 className="bento-subtitle">Clean Code</h4>
            <p className="bento-small-text">Maintainable, scalable, and highly optimized architectures.</p>
          </motion.div>

          <motion.div className="bento-card glass-panel hover-target bento-center" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <FaPaintBrush className="bento-icon text-accent-2" />
            <h4 className="bento-subtitle">Pixel Perfect</h4>
            <p className="bento-small-text">Meticulous attention to UI/UX details and fluid animations.</p>
          </motion.div>

          <motion.div className="bento-card glass-panel hover-target bento-center" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
            <FaServer className="bento-icon text-accent-3" />
            <h4 className="bento-subtitle">Scalable Systems</h4>
            <p className="bento-small-text">Building resilient backend services capable of handling growth.</p>
          </motion.div>

          <motion.div className="bento-card glass-panel hover-target bento-center" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
            <FaRocket className="bento-icon" style={{ color: '#ec4899' }} />
            <h4 className="bento-subtitle">Performance First</h4>
            <p className="bento-small-text">From fast loading times to 60fps animations, speed is foundational.</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
